
import { useEffect, useMemo, useState } from "react";
import { authenticationSeletor, } from "@store/slices/authenticationSlice";
import { useDispatch, useSelector } from "react-redux";
import services from "@api/services";
import "@smastrom/react-rating/style.css";
import { onLogout } from "@utils/utils";
import { Link, useNavigate, useLocation } from 'react-router-dom';
import SklHotelCard from "@shared/skeleton/SklHotelCard";
import { FOOD_PLAN, PROPERTY_CATEGORY_COLORS } from '@constant/constants';
import { baseImgUrl } from "@api/client/api";
import Moment from "react-moment";
import { IoLocationOutline, MdKeyboardArrowDown } from '@assets/Icons';
import { createLogs } from "@store/slices/PropertyData";
import moment from "moment";

const UserProfile = () => {

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  let forMobileView = location?.state?.activeTab || 'both';
  const limit = 10
  const { access_token, taDetails } = useSelector(authenticationSeletor);

  const [sortValue, setSortValue] = useState("");
  const [oldNew, setOldNew] = useState(-1);
  const [loading, setLoading] = useState(true);
  const [bookings, setBookings] = useState([]);
  const [categoryData, setCategoryData] = useState([]);
  const [cancelPopup, setCencelPopup] = useState(0);
  const [reasonVal, setReasonVal] = useState("");
  const [showInd, setShowInd] = useState([]);
  const [bookedHotel, setBookedHotel] = useState([]);
  const [page, setPage] = useState(1);
  const [hotelPagination, setHotelPagination] = useState({})
  const [checkReview, setReviewCheck] = useState({
    first: "",
    second: "",
    third: "",
    fourth: "",
    fifth: "",
    sixth: "",
  });
  const [mode, setMode] = useState('bookings')

  const fetchBookings = async () => {
    setLoading(true)
    try {
      const res = await services.globalService.taBookingService(taDetails?.taCode)
      if (res.data.status == true) {
        setBookings(res?.data?.data)
        setBookedHotel(res?.data?.data)
      }
    }
    catch { console.log("error in fetchBookings function.") }
    finally { setLoading(false) }
  }

  useEffect(() => { fetchBookings() }, [])

  const getRoomCategory = async () => {
    try {
      const res = await services.property.getRoomCategoryService();
      if (res.status === 200) {
        setCategoryData(res?.data?.data);
      }
    } catch (error) { console.log("error in getRoomCategory function.") }
  };

  useEffect(() => { getRoomCategory() }, [])

  const setShowSection = (ind) => {
    if (showInd.includes(ind)) {
      setShowInd((i) => i.filter((i) => i !== ind));
    } else {
      setShowInd([ind]);
    }
  };

  const checkOutHandler = async (e, data) => {
    e.preventDefault();
    try {
      let arr = [];
      for (let i in checkReview) { arr.push(checkReview[i]) }
      const payload = {
        id: data.id,
        cancelledBy: `guest_${taDetails?.name}_${taDetails?.mobile}`,
        body: { bookingStatus: 4, reason: arr.toString() + " " + reasonVal },
      };
      const res = await services.globalService.updateCheckInStatusService(payload);
      if (res.status == 200) {
        const reasonValues = Object.values(checkReview).filter((val) => val && val.trim() !== "");
        const params = {
          bookingId: data.id,
          action: `Booking Cancelled  - ${reasonValues.join(", ")}`,
          actionType: `Booking Cancelled`,
          actionBy: taDetails?.name,
          userType: "Guest",
          cancelBy: "guest",
          paymentMode: null
        };
        dispatch(createLogs(params));
        setCencelPopup(0);
        setReasonVal("");
      }
    } catch (error) { console.log("error in checkOutHandler function.") }
  };

  const setCheckReview = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    setReviewCheck({ ...checkReview, [name]: value });
  };

  useEffect(() => {
    if (sortValue == "") {
      setBookings(bookedHotel);
    } else {
      const filterBookings = bookedHotel?.filter(
        (i) => i.bookingStatus == sortValue
      );
      setBookings(filterBookings);
    }
  }, [sortValue]);

  useMemo(() => {
    let filterVal = [];
    if (oldNew == 1) {
      filterVal = bookedHotel.sort(function (a, b) {
        var keyA = new Date(a.createdAt),
          keyB = new Date(b.createdAt);
        if (keyA > keyB) return -1;
        if (keyA < keyB) return 1;
        return 0;
      });
    } else if (oldNew == 0) {
      filterVal = bookedHotel.sort(function (a, b) {
        var keyA = new Date(a.createdAt),
          keyB = new Date(b.createdAt);
        if (keyA < keyB) return -1;
        if (keyA > keyB) return 1;
        return 0;
      });
    }
    filterVal = bookedHotel;
    setBookings(filterVal);
  }, [oldNew]);


  const [taBookings, setTaBookings] = useState([]);
  const [ledgerData, setLedgerData] = useState([]);

  const fetchTaBooking = async () => {
    try {
      const res = await services.property.getTaBookingEnqueryService(taDetails?.taCode)
      if (res.status === 200) {
        setTaBookings(res?.data?.data)
      }
    }
    catch { }
  }
  const fetchLedgersData = async () => {
    try {
      const res = await services.property.getTaLedgerService(taDetails?.taCode)
      console.log('fetchLedgersData', res)
      if (res.status === 200) {
        setLedgerData(res?.data?.data)
      }
    }
    catch { }
  }

  useEffect(() => {
    fetchTaBooking()
    fetchLedgersData()
  }, [taDetails])

  console.log('taBookings', taBookings)

  // const addCommision = async () => {
  //   const payload = {
  //     taCode: "TA0004",
  //     bookingId: "1953651553",
  //     noOfRooms: 2,
  //     bookingAmount: "15000",
  //     totalCommisssion: "1200",
  //     status: 1,
  //     createdBy: 10
  //   }
  //   const res = await services.property.addCommisionService(payload)
  //   console.log('addCommision', res)
  // }

  console.log('first', ledgerData)

  return (
    <>
      <div className='profile-page'>
        <div className='container'>
          <div className='row'>
            {
              (forMobileView == 'profile' || forMobileView == 'both') && (
                <div className='col-lg-4'>
                  <div className='ta-profile'>
                    <div className='name'>
                      <h3>{taDetails?.firstName + ' ' + taDetails?.lastName}</h3>
                    </div>
                    <div className='content'>
                      <p>
                        <span className='one'>Mobile</span>
                        <span className='tow'>{taDetails?.mobile}</span>
                      </p>
                      <p>
                        <span className='one'>Email</span>
                        <span className='tow'>{taDetails?.email}</span>
                      </p>
                      <p>
                        <span className='one'>TA Code</span>
                        <span className='tow'>{taDetails?.taCode}</span>
                      </p>
                      <p>
                        <span className='one'>Business Name</span>
                        <span className='tow'>{taDetails?.businessName}</span>
                      </p>
                      <p>
                        <span className='one'>Commission</span>
                        <span className='tow'>{taDetails?.commission}%</span>
                      </p>
                      <p>
                        <span className='one'>State</span>
                        <span className='tow'>{taDetails?.stateName?.name}</span>
                      </p>
                      <p>
                        <span className='one'>City</span>
                        <span className='tow'>{taDetails?.cityName?.name}</span>
                      </p>
                      <p>
                        <span className='one'>Pincode</span>
                        <span className='tow'>{taDetails?.pincode}</span>
                      </p>
                      <div className="documents">
                        <h6>Documents</h6>
                        <div className="col">
                          <img
                            src={baseImgUrl + taDetails?.aadharCertificate?.replace("/uploads", "")}
                          />
                        </div>
                        <div className="col">
                          <img
                            src={baseImgUrl + taDetails?.gstCertificate?.replace("/uploads", "")}
                          />
                        </div>
                        <div className="col">
                          <img
                            src={baseImgUrl + taDetails?.panCertificate?.replace("/uploads", "")}
                          />
                        </div>
                        <div className="col">
                          <img
                            src={baseImgUrl + taDetails?.cancelCheque?.replace("/uploads", "")}
                          />
                        </div>
                      </div>
                      {
                        access_token && (
                          <button type='button' className='btn btn-secondary btn-block mt-3' onClick={() => onLogout(navigate)}>Logout</button>
                        )
                      }
                    </div>
                  </div>
                </div>
              )
            }
            {
              (forMobileView == 'bookings' || forMobileView == 'both') && (
                <div className='col-lg-8'>
                  <div className='booking-history'>
                    <div className="flex justify-content-between">
                      <h2 className="m-0">Booking History</h2>
                      <Link to='/create-booking' className="btn btn-primary btn-sm">Create Booking</Link>
                    </div>
                    <div className='booking-tabs d-flex align-items-center justify-content-between mt-4 mb-4'>
                      <ul>
                        <li
                          className={mode == "bookings" ? "active" : ""}
                          onClick={() => setMode("bookings")}
                        >
                          Bookings
                        </li>
                        <li
                          className={mode == "ledger" ? "active" : ""}
                          onClick={() => setMode("ledger")}
                        >
                          Ledger
                        </li>
                      </ul>
                      <select
                        className='field-control'
                        id="sortType"
                        name="sort"
                        onChange={(e) => setOldNew(e.target.value)}>
                        <option value="">Sort By</option>
                        <option value="0">Old To New</option>
                        <option value="1">New To Old</option>
                      </select>
                    </div>
                    {loading ? (
                      <SklHotelCard />
                    ) :
                      mode == 'bookings' ?
                        [...taBookings].reverse()?.map((data, key) => {
                          return (
                            <div className='taBooking-card' key={key}>
                              <div className="date">
                                <p className='pb-2'>
                                  <span>Booking Date - </span>
                                  <Moment format="DD MMM YYYY">
                                    {data.fromDate}
                                  </Moment>{" to "}
                                  <Moment format="DD MMM YYYY">{data.toDate}</Moment>
                                </p>
                                <p>
                                  <span>TA Code - </span>
                                  {data.taCode}
                                </p>
                              </div>
                              <div className='info'>
                                <p><span>Commission Percentage - </span> {data?.commissionPercentage}</p>
                                <p><span>Commission Per Room - </span> {data?.commissionPerRoom}</p>
                                <p><span>No. Of Rooms - </span> {data?.noOfRooms}</p>
                                <p>{data?.adults} Adult | {data?.children} Child | {data?.noOfRooms} Room</p>
                              </div>
                              <div className='info'>
                                <h4>{ }</h4>
                                <p>
                                  <span>Zone - </span>
                                  <span>{data?.zone}</span>
                                </p>
                                <p>
                                  <span>State - </span>
                                  <span>{data?.state}</span>
                                </p>
                                <p>
                                  <span>City - </span>
                                  <span>{data?.city}</span>
                                </p>
                                <p>
                                  <span>Locality - </span>
                                  <span>{data?.locality}</span>
                                </p>


                              </div>


                            </div>
                          )
                        }) :
                        <table className="table-ledger">
                          <thead>
                            <tr>
                              <th>Date</th>
                              <th>TA Code</th>
                              <th>Booking Id</th>
                              <th>No. Of Rooms</th>
                              <th>Booking Amount</th>
                              <th>Total Commisssion</th>
                            </tr>
                          </thead>
                          <tbody>
                            {
                              ledgerData?.map((item) => {
                                return (
                                  <tr key={item?.id}>
                                    <td>
                                      {moment(item?.createdAt).format('DD-MM-YYYY')}
                                    </td>
                                    <td>{item?.taCode}</td>
                                    <td>{item?.bookingId}</td>
                                    <td>{item?.noOfRooms}</td>
                                    <td>{item?.bookingAmount}</td>
                                    <td>{item?.totalCommisssion}</td>
                                  </tr>
                                )
                              })
                            }
                          </tbody>
                        </table>
                    }
                  </div>
                </div>
              )
            }
          </div>
        </div>
      </div>
    </>
  )
}

export default UserProfile